import { Flex } from '@chakra-ui/react'
import React from 'react'

interface PanelBodyPropsType {
  children: React.ReactNode
  px?: string
  pb?: string
  height?: object | string
  overflowY?: object
}

const PanelBody: React.FC<PanelBodyPropsType> = ({
  px,
  height,
  children,
  overflowY,
  pb
}) => (
  <Flex
    data-testid="panel-body"
    flexDirection="column"
    overflow="hidden"
    flex="1"
  >
    {children}
  </Flex>
)

export default PanelBody
